import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import './styles.scss'
import {
    AppLayout,
} from "@amzn/awsui-components-react";
import SideNav from "./SideNav";

import FirstPassEntityListComponent from "./Components/FirstPassEntityListComponent";
export default (props) => {
    const [NavOpen, setNavOpen] = useState(false);
    const [customSideNavitems, setCustomSideNavitems] = useState([
        {
            "type": "link",
            "text": "About",
            "href": `/firstpass`
        },

        { "type": "divider" },

        {
            "type": "link",
            "text": "Back",
            "href": "/"
        },
    ])
    const userId = useSelector((globalState) => globalState.auth.userId);
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)

    useEffect(() => {
    }, [userId, currentStage])

    const HomeContent = (
        <FirstPassEntityListComponent></FirstPassEntityListComponent>
    )

    return (
        <AppLayout
            disableContentPaddings={true}
            navigation={<SideNav activeHref={`/firstpass`} customSideNavitems={customSideNavitems} />}
            navigationOpen={NavOpen}
            content={HomeContent}
            headerSelector="#TopBar"
            toolsHide={true}
            navigationHide={true}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            headerVariant="high-contrast"
        />

    );
}
